import * as React from "react"

function SameDay(props) {
  return (
    <svg
      viewBox="0 0 37 37"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <circle
        cx={203.698}
        cy={125.424}
        r={70.298}
        fill="#e5eeff"
        transform="translate(-34.458 -14.24) scale(.2583)"
      />
      <path
        d="M15.34 13.624l.034-1.667c0-.2-.133-.334-.333-.334s-.334.134-.334.334l-.033 1.667c-.6.133-1.034.7-1.034 1.333 0 .4.167.734.4 1l-1.233 2.034c-.1.167-.033.367.133.467.167.1.367.034.467-.133l1.234-2.034c.133.033.266.067.4.067.767 0 1.367-.634 1.367-1.367-.034-.7-.5-1.234-1.067-1.367zm-.366 2.034c-.4 0-.7-.334-.7-.7 0-.4.333-.7.7-.7.4 0 .7.333.7.7 0 .366-.333.7-.7.7zM14.974 9.756c.2 0 .333-.133.333-.333v-.667c0-.2-.133-.333-.333-.333s-.333.133-.333.333v.667c0 .167.133.333.333.333zM14.974 20.125c-.2 0-.333.134-.333.334v.666c0 .2.133.334.333.334s.333-.134.333-.334v-.666a.359.359 0 00-.333-.334zM9.773 14.957c0-.2-.133-.333-.333-.333h-.667c-.2 0-.334.133-.334.333s.134.334.334.334h.667a.359.359 0 00.333-.334zM20.142 14.957c0 .2.133.334.333.334h.667c.2 0 .333-.134.333-.334s-.133-.333-.333-.333h-.667a.334.334 0 00-.333.333zM9.406 12.123l.6.334c.167.1.367.033.467-.133.1-.167.033-.367-.133-.467l-.6-.334c-.167-.1-.367-.033-.467.134-.067.2-.034.4.133.466zM12.373 19.425c-.166-.1-.366-.033-.466.133l-.334.6c-.1.167-.033.367.134.467.166.1.366.034.466-.133l.334-.6c.067-.167.033-.367-.134-.467zM17.541 10.456c.167.1.367.034.467-.133l.333-.6c.1-.167.034-.367-.133-.467-.167-.1-.367-.033-.467.134l-.333.6c-.067.166-.033.366.133.466zM12.307 10.49c.166-.1.2-.3.1-.467l-.334-.6c-.1-.167-.3-.2-.466-.1-.167.1-.2.3-.1.467l.333.6c.1.133.3.2.467.1zM10.04 17.491l-.6.334c-.167.1-.2.3-.1.466.1.167.3.2.466.1l.6-.333c.167-.1.2-.3.1-.467-.1-.166-.3-.2-.466-.1zM19.875 12.424l.6-.334c.167-.1.2-.3.1-.467-.1-.166-.3-.2-.467-.1l-.6.334c-.166.1-.2.3-.1.467.1.133.3.166.467.1z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path
        d="M28.944 19.292s0-.034 0 0c-.067-.034-6.202-3.401-6.268-3.401.033-.333.066-.634.066-.934 0-4.3-3.5-7.801-7.801-7.801-4.268 0-7.769 3.5-7.769 7.801s3.501 7.802 7.769 7.802c.333 0 .733-.033 1.133-.1v2.267c0 .1.067.234.167.267l6.168 3.9c.067.034.1.067.167.067.066 0 .133-.033.166-.033l6.235-3.3a.35.35 0 00.167-.3v-5.935c0-.134-.067-.234-.2-.3zm-.834.3l-1.467.8-5.534-3.034 1.467-.767 5.534 3zm-2.8 1.7l-5.735-3.134.834-.467 5.9 3.234v1.667l-.8.5v-1.5c0-.133-.1-.267-.2-.3zm-2.701 1.3l-5.501-3.1 1.767-.934 5.601 3.034-1.867 1zm-7.668-.533c-3.901 0-7.102-3.2-7.102-7.102 0-3.934 3.2-7.134 7.102-7.134a7.143 7.143 0 017.035 8.335s-5.668 3.034-5.735 3.034c-.1.066-.167.2-.167.3v2.5c-.4.034-.8.067-1.133.067zm1.8 2.667V20.06l5.501 3.1v5.068l-5.5-3.5zm6.168 3.534v-5.067l1.9-1.034v1.5a.35.35 0 00.167.3c.1.067.234.067.334 0l1.5-.833a.35.35 0 00.167-.3v-1.867l1.467-.8v5.167l-5.535 2.934z"
        fill="#052879"
        fillRule="nonzero"
      />
      <g>
        <path
          d="M21.359 25.209l-3.634-2.1c-.167-.1-.367-.034-.467.133-.1.166-.033.366.133.466l3.634 2.067c.167.1.367.034.467-.133.067-.133 0-.367-.133-.433z"
          fill="#052879"
          fillRule="nonzero"
        />
      </g>
      <g>
        <path
          d="M21.325 26.576l-3.634-2.134c-.166-.1-.366-.034-.466.133-.1.167-.034.367.133.467l3.634 2.1c.167.1.367.034.467-.133.066-.167 0-.367-.134-.433z"
          fill="#052879"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}

export default SameDay
